export const ROUTES = {
  home: '/',
  services: '/services',
  creative: '/creative-studio',
  cases: '/cas-clients',
  method: '/methode',
  faq: '/faq',
  audit: '/audit',
  auditGratuit: '/audit-gratuit'
} as const;

// ancres de /services
export const SERVICES_ANCHORS = {
  ads: '#ads',
  aplus: '#a-plus',
  catalog: '#catalog-health',
  expansion: '#expansion-scale',
  ops: '#ops-fba-fbm',
  care: '#customer-care'
} as const;

// liens CTA (utiliser partout)
export const CTA_LINKS = {
  audit: '/espace-client',
  results: '/cas-clients',
  services: '/services',
  whatsapp: 'WHATSAPP_WIDGET', // handled by JS (fallback wa.me)
  calcom: '/audit-gratuit' // Direct vers page avec Cal.com intégré
} as const;